import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import "./EXHIMainView.css";

import { LoadingSpinner } from "Projects/CC_cubi_clan_project/GlobalComponents/LoadingSpinner/LoadingSpinner";
import { NavMenu } from "Projects/CC_cubi_clan_project/GlobalComponents/NavMenu/NavMenu";
import EXHIHomeView from "Projects/EXHI_exhibiciones_project/Views/EXHIHomeView/EXHIHomeView";
import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";

export default function EXHIMainView({ hostAppCode }) {
  const [cookies] = useCookies();
  const [isLoggedInCallback, setIsLoggedInCallback] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // null = checking, true = enabled, false = disabled
  const [exhiEnabled, setExhiEnabled] = useState(hostAppCode ? null : true);

  const isLoggedIn = !!cookies.SESSION_ID || isLoggedInCallback;

  useEffect(() => {
    if (!hostAppCode) return;
    doFetch("SSO", "getAppEstado?app=" + hostAppCode, { _silent: true })
      .then((r) => r.json())
      .then((data) => {
        if (data?.STATE === "SUCCESS" && data.DATA?.exhiEnabled) {
          setExhiEnabled(true);
        } else {
          setExhiEnabled(false);
        }
      })
      .catch(() => setExhiEnabled(false));
  }, [hostAppCode]);

  if (exhiEnabled === null) return null;

  if (exhiEnabled === false) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", flexDirection: "column", fontFamily: "sans-serif", color: "#555" }}>
        <h2>Exhibiciones no disponible</h2>
        <p>Esta funcionalidad no está habilitada para esta aplicación.</p>
      </div>
    );
  }

  return (
    <div className="exhi-main">
      <LoadingSpinner isLoading={isLoading} />
      <NavMenu
        title={hostAppCode ? `Exhibiciones · ${hostAppCode}` : "Exhibiciones"}
        appCode="EXHI"
        onLoggedIn={setIsLoggedInCallback}
        onLoading={setIsLoading}
      />
      {isLoggedIn && (
        <EXHIHomeView hostAppCode={hostAppCode} onLoading={setIsLoading} />
      )}
    </div>
  );
}
